"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.search");
var _invoiceEdit = _interopRequireDefault(require("@/views/shop/invoiceEdit.vue"));
var _invoiceTable = _interopRequireDefault(require("@/views/shop/invoiceTable.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'invoice',
  // 菜品活动-推荐购
  components: {
    invoiceTable: _invoiceTable.default,
    invoiceEdit: _invoiceEdit.default
  },
  data: function data() {
    return {
      activeName: 'table',
      taxCode: null
    };
  },
  created: function created() {},
  methods: {
    handleSuccess: function handleSuccess() {
      this.activeName = 'table';
      this.$refs.referral_purchase_table.search();
    },
    addActivity: function addActivity() {
      this.taxCode = null;
      this.activeName = 'config';
    },
    handleClick: function handleClick(tab) {
      console.log(tab);
      this.activeName = tab.name;
      if (tab.name === 'table') {
        this.taxCode = null;
      }
    },
    editActivity: function editActivity(taxCode) {
      this.activeName = 'config';
      this.taxCode = taxCode;
      console.log("传参：" + taxCode);
    }
  }
};